import { getOrdersInvoicesDt } from "~/helpers/backendHelper";
import { getOrdersInvoicesDtErr, getOrdersInvoicesDtOk } from "./actions";
import { GET_ORDERS_INVOICES_DT } from "./actionTypes";
import { takeEvery, put, call, CallEffect, PutEffect } from "redux-saga/effects";

/********** DATATABLE **********/

function* onGetOrdersInvoicesDt(action: { type: string; payload: { params: any } }): Generator<CallEffect | PutEffect<any>, void, any> {
  try {
    const response = yield call(getOrdersInvoicesDt, action.payload.params);
    yield put(getOrdersInvoicesDtOk(response));
  } catch (error) {
    yield put(getOrdersInvoicesDtErr(error as Error));
  }
}

function* ordersInvoicesSaga() {
  yield takeEvery(GET_ORDERS_INVOICES_DT, onGetOrdersInvoicesDt);
}

export default ordersInvoicesSaga;